(function () {
  'use strict';

  var productJsonEl = document.getElementById('LumiifloraProductJson');
  var subscriptionRoot = document.querySelector('.prod-lumiiflora__subscription[data-subscription-ui="custom"]');

  if (!productJsonEl || !subscriptionRoot) {
    return;
  }

  var product = JSON.parse(productJsonEl.textContent);

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.money_format) {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  function getSelectedVariantId() {
    var select = document.getElementById('productSelect');
    if (select && select.value) {
      return parseInt(select.value, 10);
    }
    return product.selected_or_first_available_variant || (product.variants[0] && product.variants[0].id);
  }

  function getVariant(variantId) {
    return product.variants.find(function (variant) {
      return variant.id === variantId;
    });
  }

  function getAllocation(variant, planId) {
    if (!variant || !variant.selling_plan_allocations) {
      return null;
    }

    return variant.selling_plan_allocations.find(function (allocation) {
      return allocation.selling_plan_id === planId;
    });
  }

  function syncSelectedState() {
    var checked = subscriptionRoot.querySelector('input[name="selling_plan_choice"]:checked');
    var options = subscriptionRoot.querySelectorAll('.prod-lumiiflora__purchase-option');

    options.forEach(function (option) {
      option.classList.remove('is-selected');
    });

    if (checked) {
      var selectedOption = checked.closest('.prod-lumiiflora__purchase-option');
      if (selectedOption) {
        selectedOption.classList.add('is-selected');
      }
    }
  }

  function syncSellingPlanInput() {
    var checked = subscriptionRoot.querySelector('input[name="selling_plan_choice"]:checked');
    var input = document.getElementById('selling_plan_input');

    if (input) {
      input.value = checked && checked.dataset.sellingPlan ? checked.dataset.sellingPlan : '';
    }

    syncSelectedState();
    updateDisplayedPrice();
  }

  function updateDisplayedPrice() {
    var variant = getVariant(getSelectedVariantId());
    if (!variant) {
      return;
    }

    var checked = subscriptionRoot.querySelector('input[name="selling_plan_choice"]:checked');
    var planId = checked && checked.dataset.sellingPlan ? parseInt(checked.dataset.sellingPlan, 10) : null;
    var price = variant.price;
    var compareAt = variant.compare_at_price;

    if (planId) {
      var allocation = getAllocation(variant, planId);
      if (allocation) {
        price = allocation.price;
        compareAt = allocation.compare_at_price;
      }
    }

    var priceEl = document.querySelector('.prod-lumiiflora .enj-product-price');
    var compareEl = document.querySelector('.prod-lumiiflora .enj-product-price-compare');

    if (priceEl) {
      priceEl.textContent = formatMoney(price);
    }

    if (compareEl) {
      if (compareAt && compareAt > price) {
        compareEl.textContent = formatMoney(compareAt);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  function updateSubscriptionOptions() {
    var variant = getVariant(getSelectedVariantId());
    if (!variant) {
      return;
    }

    var oneTimePrice = subscriptionRoot.querySelector('[data-one-time-price]');
    if (oneTimePrice) {
      oneTimePrice.textContent = formatMoney(variant.price);
    }

    var checkedPlanStillAvailable = false;
    var checkedInput = subscriptionRoot.querySelector('input[name="selling_plan_choice"]:checked');
    var planOptions = subscriptionRoot.querySelectorAll('[data-selling-plan-id]');

    planOptions.forEach(function (option) {
      var planId = parseInt(option.dataset.sellingPlanId, 10);
      var allocation = getAllocation(variant, planId);
      var input = option.querySelector('input[name="selling_plan_choice"]');
      var priceEl = option.querySelector('[data-plan-price="' + planId + '"]');

      if (allocation) {
        option.classList.remove('prod-lumiiflora__purchase-option--hidden');
        if (priceEl) {
          priceEl.textContent = formatMoney(allocation.price);
        }
        if (input && input.checked) {
          checkedPlanStillAvailable = true;
        }
      } else {
        option.classList.add('prod-lumiiflora__purchase-option--hidden');
        if (input) {
          input.checked = false;
        }
      }
    });

    if (checkedInput && checkedInput.dataset.sellingPlan && !checkedPlanStillAvailable) {
      var oneTimeInput = subscriptionRoot.querySelector('input[name="selling_plan_choice"][data-selling-plan=""]');
      if (oneTimeInput) {
        oneTimeInput.checked = true;
      } else {
        var firstVisible = subscriptionRoot.querySelector('[data-selling-plan-id]:not(.prod-lumiiflora__purchase-option--hidden) input');
        if (firstVisible) {
          firstVisible.checked = true;
        }
      }
    }

    syncSellingPlanInput();
  }

  subscriptionRoot.querySelectorAll('input[name="selling_plan_choice"]').forEach(function (input) {
    input.addEventListener('change', syncSellingPlanInput);
  });

  var productSelect = document.getElementById('productSelect');
  if (productSelect) {
    productSelect.addEventListener('change', updateSubscriptionOptions);
  }

  window.LumiifloraSubscriptions = {
    onVariantChange: updateSubscriptionOptions
  };

  updateSubscriptionOptions();
})();
